import React, { useState, useEffect } from "react";

export function usePesq(fetch, pesq, setDadosPesq, modelo) {
    const [loading, setLoading] = useState(false);

    const setDados = d => {
        setDadosPesq(modelo, d);
    };

    useEffect(() => {
        if (!pesq[modelo]) {
            setLoading(true);
            fetch()
                .get("/" + modelo)
                .then(function (response) {
                    setLoading(false);
                    setDados(response.data);
                })
                .catch(function (error) {
                    setLoading(false);
                });
        }
    }, []);

    return [pesq, loading];
}